import { FEATURE_DISCOVERY } from './types';
import { applicationPropertiesSelector } from '../selectors/properties';

/**
 * Note featureId param should be bits. You can un/set more than 1 at once: 'FEAT1|FEAT2'
 * Please see the tests for examples
 */
export const applicationFeatureDiscoveredAction = (featureId, set = true) => (
  dispatch,
  getState,
) => {
  const { featureDiscovery: prevVal } = applicationPropertiesSelector(getState());
  // eslint-disable-next-line no-bitwise
  const newVal = set ? prevVal | featureId : prevVal & ~featureId;
  dispatch({
    type: FEATURE_DISCOVERY,
    payload: newVal,
  });
};
